import { createModel } from "@/util/ModelUtil";
import { CourseType } from "@/enum/course/CourseType";

export default class CourseModel {
  constructor(
    public id: number = 0,
    public title: string = "",
    public subTitle: string = "",
    public type: CourseType = CourseType.E_LEARNING,
    public level: number = 0,
    public whatYouLearn: Array<string> = [],
    public requirement: Array<string> = [],
    public target: Array<string> = [],
    public description: string = "",
    public inclusion: Array<string> = [],
    public bannerImageUrl: string = "",
    public cardImageUrl: string = "",
    public cardInfo: string = "",
    public wishlistCount: number = 0,
    public reviewCount: number = 0,
    public reviewRating: number = 0,
    public lectureCount: number = 0,
    public exposure: boolean = false,
    public createdAt: string = "",
    public updatedAt: string = "",
    public unAnsweredCount: number = 0
  ) {}

  public static create(course?: Course): CourseModel {
    return createModel<CourseModel>(CourseModel, course);
  }
}
